<template>
  <section v-if="data.length" class="cms-content">
    <i18n-t
      v-if="lastModifiedDate"
      class="text-left"
      keypath="cms.lastmodified"
      scope="global"
      tag="p"
    >
      <template #date>
        <strong>
          {{ lastModifiedDate }}
        </strong>
      </template>
    </i18n-t>
    <ContentfulRenderer
      v-for="(block, i) in data"
      :key="`block-${i}`"
      class="text-left content"
      :data="block.content"
    />
  </section>
</template>

<script lang="ts" setup>
import type { ContentBlock } from '~~/@types/generated/cms/graphql-schema-types'

type CmsContentProps = {
  data: ContentBlock[]
}

const props = defineProps<CmsContentProps>()

const lastModifiedDate = computed(() => {
  const acknowledgementDate = props.data.find(
    (block: ContentBlock) => block.acknowledgmentDate,
  )?.acknowledgmentDate

  if (!acknowledgementDate) return

  return new Date(acknowledgementDate).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  })
})
</script>

<style lang="scss" scoped>
.cms-content {
  :deep(.content) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      @include token-headline-h5-headline;

      margin-bottom: token('size/space/gap/050');
      scroll-margin-top: 5rem;
    }

    p {
      margin-bottom: token('size/space/gap/200');
    }

    ul {
      margin-bottom: token('size/space/gap/400');
      padding-left: token('size/space/gap/400');
      list-style: disc;

      li {
        &::marker {
          content: '●  ';
          color: token('color/icon/accent/success/success');
        }

        + li {
          margin-top: token('size/space/gap/200');
        }

        p {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
